export const Default_Login_Page = `
<div style="text-align: center; max-width: 400px; padding: 20px; background: white; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
    <h1 style="color: #2A3F54; margin-bottom: 10px;">Welcome to Infer Surveys</h1>
    <p style="color: #555; margin-bottom: 30px;">
      Thank you for being here.<br />
      We’ve crafted a smooth and secure experience just for you.
    </p>
  </div>
`;
